import { z } from 'zod';
import { zDocketStatus, zDocketType, zPrinterInterface } from '../enums';
import { printAttemptSchema } from './printAttemptSchema';

export const docketSchema = z.object({
  actualPosPrinterIdentifier: z.string(),
  actualPosPrinterInterface: zPrinterInterface,
  desiredPosPrinterIdentifier: z.string(),
  /**
   * @deprecated Use docketPayload instead. Only kept for backward compatibility.
   */
  docketHtml: z.string().optional(),
  /**
   * base64 image data string for debugging purposes only
   */
  debugImageBase64: z.string().nullable().default(null).optional(), // May not be set for existing Dockets yet
  docketPayload: z.string().nullable().default(null),
  docketTemplateUuid: z.string(),
  docketType: zDocketType,
  expireAt: z.number(),
  localCreatedAt: z.number(),
  localUpdatedAt: z.number(),
  printAttempts: z.array(printAttemptSchema).default([]),
  printJobUuid: z.string().nullable().default(null),
  shouldRetry: z.boolean(),
  status: zDocketStatus,
  uuid: z.string(),
});
export type Docket = z.output<typeof docketSchema>;

export const docketStrictSchema = docketSchema.safeExtend({
  docketTemplateUuid: z.guid(),
  printJobUuid: z.guid().nullable(),
  uuid: z.guid(),
});
